import { ifyouApi } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

// 라이브 배포 - 플랫폼
export const liveDeployApis = {
  // 2029.6.20.api 업그레이드
  dataDeploy: (user_id) =>
    ifyouApi
      .post(`deploy`, {
        user_id: user_id,
        func: 'deployPackageLocalize',
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};
